import { Controller } from "react-hook-form";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { Stack, Typography, Box } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";

type Props = {
  control: any;
  start: string | null;
  end: string | null;
  name: string;
};

export default function CustomDateField({ control, start, end, name }: Props) {
  const startDateTime = start ? dayjs(start) : null;
  const endDateTime = end ? dayjs(end) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={1} sx={{ width: "100%", maxWidth: 350 }}>
        <Controller
          name={name}
          control={control}
          defaultValue={start ? dayjs(start) : null}
          rules={{ required: false }}
          render={({ field }) => {
            return (
              <Box>
                <DateTimePicker
                  {...field}
                  label="Execution Time"
                  value={field.value ? dayjs(field.value) : (startDateTime || null)}
                  minDateTime={startDateTime || undefined}
                  maxDateTime={endDateTime || undefined}
                  minutesStep={1}
                  // Enabling year/month/day allows selecting dates within the encounter range
                  views={["year", "month", "day", "hours", "minutes"]}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  ampm={true}
                  onChange={(newValue: Dayjs | null) => {
                    field.onChange(newValue);
                  }}
                  format="DD-MM-YYYY hh:mm A"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      variant: "outlined",
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#fcfcfc",
                        },
                      },
                    },
                    actionBar: {
                      actions: ["clear", "today"],
                    },
                  }}
                />
                {(startDateTime || endDateTime) && (
                   <Box sx={{ mt: 0.5, px: 1, display: 'flex', justifyContent: 'space-between' }}>
                      {startDateTime && (
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                          Start: {startDateTime.format("DD-MM-YYYY hh:mm A")}
                        </Typography>
                      )}
                      {endDateTime && (
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                          End: {endDateTime.format("DD-MM-YYYY hh:mm A")}
                        </Typography>
                      )}
                   </Box>
                )}
              </Box>
            );
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
